<template>
  <v-row>
    <v-col>
      <v-sheet height="900">
        <v-calendar
          ref="calendar"
          :now="today"
          :value="today"
          :events="events"
          color="primary"
          type="week"
        ></v-calendar>
      </v-sheet>
    </v-col>
  </v-row>
</template>

<script>
export default {
  data: () => ({
    today: "2019-01-08",
    events: [
      {
        start: "2019-01-09T16:30:00",
        end: "2019-01-09T17:00:00",
        multiple: false,
        name: "Opening Ceremony",
      },
      {
        start: "2019-01-10",
        multiple: false,
        name: "Opening Plenary",
      },
      {
        start: "2019-01-07T17:00:00",
        end: "2019-01-07T18:00:00",
        multiple: false,
        name: "Welcome Reception",
      },
    ],
  }),
  mounted() {
    this.$refs.calendar.scrollToTime("08:00");
  },
};
</script>
